import { atom } from 'jotai';
import type { BidderListType } from '@/types/bidderList';

/**
 * Production state (NOT mock state — see PLAN gate N1, SP2-4833).
 *
 * Drives the open/closed state of the AddBidderModal and carries the context
 * needed to determine which list type's modal to render:
 *   - null            → modal closed
 *   - 'AUTO_ACCEPTED' → opened from the auto-approval list tab
 *   - 'AUTO_DECLINED' → opened from the auto-decline list tab
 *
 * Generalised in SP2-4836 from the original boolean atom (SP2-4835).
 *
 * IMPORTANT: this atom MUST NOT be deleted by SP2-4906's mock cleanup. It is
 * deliberately filed under `atoms/bidderList/` (production) rather than
 * `atoms/bidderListMockScenario/` (mock-only) so the mock-folder rm survives
 * without touching this file.
 */
export const bidderListAddBidderModalAtom = atom<BidderListType | null>(null);
